import { render, staticRenderFns } from "./bmiChart.vue?vue&type=template&id=374cf186&scoped=true"
import script from "./bmiChart.vue?vue&type=script&lang=js"
export * from "./bmiChart.vue?vue&type=script&lang=js"
import style0 from "./bmiChart.vue?vue&type=style&index=0&id=374cf186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374cf186",
  null
  
)

export default component.exports